export const SHOW_GUARANTEE = false;
export const REPLAY_VIDEO_URL = "";
export const APPLICATION_URL = "";
export const APPLY_CTA_LABEL = "✓ START MY APPLICATION & REQUEST MY REVIEW";
